var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.6316H6.25V12.3684H9.25V11.6316H10.75V10.8947H12.25V10.1579H13V10.8947H12.25V11.6316H11.5V12.3684H10.75V13.1053H10V13.8421H10.75V14.5789H11.5V15.3158H12.25V16.0526H13.75V16.7895H14.5V17.5263H15.25V18.2632H16V19H16.75V18.2632H17.5V14.5789H18.25V8.68421H19V5H17.5V5.73684H15.25V6.47368H13.75V7.21053H11.5V7.94737H9.25V8.68421H7.75V9.42105H5.5V10.1579H4V11.6316H5.5Z",
    fill: "#FCFF62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H3V23H21V24Z",
    fill: "#FCFF62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H2V22H3V23Z",
    fill: "#FCFF62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23H21V22H22V23Z",
    fill: "#FCFF62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H1V21H2V22Z",
    fill: "#FCFF62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22H22V21H23V22Z",
    fill: "#FCFF62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H0V3H1V21Z",
    fill: "#FCFF62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H23V3H24V21Z",
    fill: "#FCFF62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H1V2H2V3Z",
    fill: "#FCFF62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H22V2H23V3Z",
    fill: "#FCFF62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H2V1H3V2Z",
    fill: "#FCFF62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H21V1H22V2Z",
    fill: "#FCFF62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1H3V0H21V1Z",
    fill: "#FCFF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.10dd6f8344edae35813a9b9bfad70e87.svg";
export { ForwardRef as ReactComponent };